<template>
  <el-aside :style="asideStyle">
    <vue-scroll>
      <div class="menu-padding" :style="{ height: '100%' }">
        <el-menu
          :popper-append-to-body="true"
          :collapse-transition="false"
          :class="[
            this.$i18n.locale == 'en_US' ? 'el-menu-vertical-demo-3' : 'el-menu-vertical-demo1-3',
            collapse ? 'el-menu-close' : 'el-menu-open'
          ]"
          :router="true"
          :collapse="collapse"
          :unique-opened="true"
          ref="elMenu"
          :default-active="$route.path"
          :style="menuStyle"
        >
          <div
            class="el-logo"
            :style="'background-color: #FFFFFF; color: #360D09;'"
          >
            {{ displayTitle }}
          </div>
          <sidebar-item v-for="item in this.routes" :key="item.id" :item="item"></sidebar-item>
          <el-menu-item class="single" @click="showIntercom">
            <i :class="'iconfont icon-kefu'"></i>
            <span slot="title">{{ "Help" }}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </vue-scroll>
  </el-aside>
</template>
<script>
  import lineUtil from "@/utils/humpToLine";
  import sidebarItem from "./SidebarItem";
  import Intercom from "@intercom/messenger-js-sdk";
  export default {
    name: "Aside",
    components: {
      sidebarItem
    },
    data() {
      return {
        index: "",
        isIntercomOpen: false
      };
    },
    watch: {
      $route(to) {
        if (to.path === "/main") {
          this.close(this.index);
        }
      }
    },
    methods: {
      // Intercom call
      showIntercom() {
        
        if (window.Intercom) {
          try {
            if (this.isIntercomOpen) {
              window.Intercom("hide"); // Closes the Intercom messenger
            } else {
              // Try multiple methods to show Intercom
              window.Intercom("show"); // Opens the Intercom messenger
              
              // Alternative: Show the messages view
              window.Intercom("showMessages");
              
              // Force update to make sure it's visible
              window.Intercom("update", {
                hide_default_launcher: false
              });
              
              
              // Check if the Intercom iframe is in the DOM
              setTimeout(() => {
                const intercomFrame = document.querySelector('iframe[name*="intercom"]');
                const intercomContainer = document.getElementById('intercom-container');
                
                if (intercomFrame) {
                  // Force visibility
                  intercomFrame.style.display = 'block';
                  intercomFrame.style.visibility = 'visible';
                  intercomFrame.style.opacity = '1';
                  intercomFrame.style.zIndex = '999999';
                }
                
                if (intercomContainer) {
                  intercomContainer.style.display = 'block';
                  intercomContainer.style.visibility = 'visible';
                  intercomContainer.style.opacity = '1';
                  intercomContainer.style.zIndex = '999999';
                }
              }, 100);
            }
            this.isIntercomOpen = !this.isIntercomOpen;
          } catch (error) {
            return error;
          }
        } else {
          alert("Intercom is not loaded. Please check the browser console for details.");
        }
      },
      close(index) {
        this.$refs.elMenu.close(index);
      },
      url(str) {
        return lineUtil.toLine(str);
      }
    },
    computed: {
      asideStyle() {
        const baseStyle = {
          backgroundColor: '#ffffff',
          color: '#6d6d6d',
          height: '100vh',
          transition: 'width 0.28s',
          overflow: 'hidden'
        };
        if (this.collapse) {
          baseStyle.width = '60px';
        } else if (this.$i18n.locale === 'en_US') {
          baseStyle.width = '200px';
        } else if (this.$i18n.locale === 'ja_JP') {
          baseStyle.width = '263px';
        } else {
          baseStyle.width = '182px';
        }
        return baseStyle;
      },
      menuStyle() {
        const baseStyle = {
          width: this.collapse ? '60px' : (this.$i18n.locale === 'en_US' ? '190px' : (this.$i18n.locale === 'ja_JP' ? '253px' : '182px')),
          height: '100%',
          minHeight: '100vh',
          borderRight: 'none'
        };
        return baseStyle;
      },
      displayTitle() {
        if (this.collapse) {
          const title = this.$t("aside.title");
          return typeof title === "string" && title.length > 0 ? title.charAt(0) : "";
        }
        return this.$t("aside.title");
      },
      routes() {
        return this.$store.state.menuList;
      },
      collapse() {
        return this.$store.state.collapse;
      }
    }
  };
</script>

<style lang="scss">
  .el-menu--vertical {
    .el-menu-item,
    .el-submenu__title {
      height: 35px;
      line-height: 36px;
      i {
        width: 24px;
        text-align: center;
        font-size: 15px;
        vertical-align: middle;
        margin-right: 8px !important;
      }
    }

    .el-menu-item:hover,
    .el-submenu__title:hover {
      // 3.0
      color: #ffffff !important;
      background-color: #c7cbd3 !important;

      i {
        color: #ffffff !important;
      }

      // 2.0
      // color: #ffffff !important;
      // background-color: rgba(0, 21, 41, 1) !important;
      // i {
      //     color: #ffffff !important;
      // }
    }

    .is-active {
      // 3.0
      color: #ffffff !important;
      background-color: #c7cbd3 !important;

      // 2.0
      // color: #ffffff !important;
      // background-color: rgba(24, 144, 255, 1) !important;
    }

    .is-active:hover {
      // 3.0
      color: #ffffff !important;
      background-color: #c7cbd3 !important;

      // 2.0
      // color: #ffffff !important;
      // background-color: rgba(24, 144, 255, 1) !important;
    }

    .el-menu--popup {
      min-width: 160px !important;
      border-radius: 3px;
    }
  }

  .el-submenu__icon-arrow {
    font-weight: bold;
  }
</style>
